<template>
  <div id="content">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="closeMessage()"
    ></dlnkalert>

    <!-- Gallery Section -->
    <div class="container space-1 position-relative mb-5">
      <div class="rounded-lg overflow-hidden mb-3">
        <div class="row mx-n1">
          <div class="col-6 offset-3 px-1">
            <!-- Gallery -->
            <img class="img-fluid w-100" :src="resource.default_picture_url" alt="Image par défaut">
            <!-- End Gallery -->
          </div>

          <!--            <div class="col-md-4 d-none d-md-inline-block px-1">-->
          <!--              <img class="img-fluid w-100 mb-2" :src="resource.pictures[1].url" alt="Premiere image">-->
          <!--              <img class="img-fluid w-100" :src="resource.pictures[2].url" alt="Deuxième image">-->
          <!--            </div>-->
        </div>
        <!-- End Row -->
      </div>

      <div class="text-center">
        <h1 class="text-primary mb-0">{{ resource.name }}</h1>
      </div>
    </div>
    <!-- End Gallery Section -->

    <!-- Property Description Section -->
    <div class="container space-bottom-2">
      <div class="row">
        <div class="col-12 mb-9 mb-lg-0">
          <!-- Nav Classic -->
          <ul class="nav nav-segment nav-fill" role="tablist" id="resource_tab">
            <li class="nav-item">
              <a class="nav-link" id="property-calendar-tab" role="tab"
                 data-toggle="pill" href="#property-calendar"
                 aria-controls="property-calendar" aria-selected="false">
                <div class="d-md-flex justify-content-md-center align-items-md-center">
                  <figure class="d-none d-md-block avatar avatar-lg mr-3">
                    <img class="avatar-img" src="/themes/template/img/icons/icon-63.svg" alt="SVG">
                  </figure>
                  Planning
                </div>
              </a>
            </li>
<!--            <li class="nav-item">-->
<!--              <a class="nav-link" id="property-map-tab" data-toggle="pill" href="#property-map" role="tab"-->
<!--                 aria-controls="property-map" aria-selected="false">-->
<!--                <div class="d-md-flex justify-content-md-center align-items-md-center">-->
<!--                  <figure class="d-none d-md-block avatar avatar-lg mr-3">-->
<!--                    <img class="avatar-img" src="/themes/template/img/icons/icon-8.svg" alt="SVG">-->
<!--                  </figure>-->
<!--                  Carte-->
<!--                </div>-->
<!--              </a>-->
<!--            </li>-->
          </ul>
          <!-- End Nav Classic -->

          <!-- Tab Content -->
          <div class="tab-content">
            <!-- Planning tab -->
            <div class="tab-pane show active mt-6" id="property-calendar" role="tabpanel"
                 aria-labelledby="property-calendar-tab">
              <FullCalendar :key="calendar_key" ref="reservationCalendar" :options="calendar_options"/>
            </div>

            <div class="tab-pane fade mt-6" id="property-map" role="tabpanel" aria-labelledby="property-map-tab">
              <!-- Gmap -->
              <div id="resource-map" class="h-380rem"></div>
              <!-- End Gmap -->
            </div>
          </div>
          <!-- End Tab Content -->

          <hr class="my-6">

          <h4 class="mb-4">Nous contacter pour avoir plus d'information</h4>

          <div class="row">
            <div class="col-sm-6 col-md-5">
              <!-- Media -->
              <div class="media">

                <div class="media-body">

                  <span class="d-block font-size-1 mb-1">
                    <i class="fas fa-phone mr-1"></i>
                    +1 822 012 3281
                  </span>

                  <span class="d-block font-size-1 mb-1">
                    <i class="fas fa-envelope mr-1"></i>
                    <a href="/nous-contacter">Nous contacter</a>
                  </span>
                </div>
              </div>
              <!-- End Media -->
            </div>
          </div>
          <!-- End Row -->
        </div>
      </div>
      <!-- End Row -->

      <!-- Sticky Block End Point -->
      <div id="stickyBlockEndPoint"></div>
    </div>
    <!-- End Property Description Section -->
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import frLocale from '@fullcalendar/core/locales/fr';

export default {
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  props: [
    'customer_id',
    'resource_id',
    'api_url',
  ],
  data: function () {
    const _this = this
    return {
      message: "",
      message_type: "",
      resource: Object,
      query: '',
      company: Object,
      customer: Object,
      is_admin: Boolean,
      method: 'post',
      calendar_key: 0,
      calendar_options: {
        events: _this.api_url + '/resource_sessions.json?secure_key=$2y$10$HOonH8.PZrRz23J94fRG6e5vgBzwi7aLpvGxF4bF1JsPNj1/AcRiy&customer_id=2',
        editable: false,
        navLinks: true,
        locale: frLocale,
        eventDisplay: 'block',
        dayMaxEvents: 5,
        headerToolbar: {center: 'dayGridMonth,timeGridWeek,timeGridDay'},
        plugins: [dayGridPlugin, timeGridPlugin],

        eventClick: function (info) {
          _this.eventClick(info)
        },

      },
    }
  },

  mounted() {

    let _this = this;
    this.get_resource();

    $('#resource_tab a[href="#property-calendar"]').on('shown.bs.tab', function (e) {
      _this.calendar_key++
    });

    var mymap = L.map('resource-map').setView([51.505, -0.09], 13);
    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 18,
      id: 'mapbox/streets-v11',
      tileSize: 512,
      zoomOffset: -1,
      accessToken: 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw'
    }).addTo(mymap);

  },

  methods: {

    closeMessage: function () {
      this.message = "";
      this.message_type = "";
    },


    eventClick: async function (info) {
      info.jsEvent.preventDefault()
      const _this = this
      const secure_key = await get_token();
      const sessionId = info.event.id

      let url = this.api_url + '/resource_reservations.json';

      url += '?secure_key=' + secure_key;
      url += '&customer_id=' + _this.customer_id

      let formData = new FormData();
      formData.append('resource_reservation[session_id]', sessionId)
      formData.append('resource_reservation[customer_id]', _this.customer_id)

      axios({
        method: 'post',
        url: url,
        data: formData,

      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if (status) {
              let calendar = _this.$refs.reservationCalendar.getApi()
              calendar.refetchEvents()
              _this.message = "Votre réservation est enregistrée"
              _this.message_type = "alert-success"
            } else {
              _this.message = response.data.errors;
              _this.message_type = "alert-danger";
            }
          })
          .catch(function (response) {
            alert('Erreur inconnu');
          });
    },

    get_resource: async function () {
      const _this = this
      const secure_key = await get_token();
      let url = this.api_url + '/resources/' + _this.resource_id + '.json';

      url += '?secure_key=' + secure_key;
      url += '&customer_id=' + _this.customer_id;

      axios.get(url)
          .then(function (response) {
            _this.resource = response.data;
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },
  },

}

</script>